// extracted by mini-css-extract-plugin
export default {"left-side-wrapper":"left-side-wrapper-30b7"};